import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"350px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("loading")), 1)
      ]))
    : (_openBlock(), _createBlock(_component_apexchart, {
        key: 1,
        type: "bar",
        height: "350",
        options: _ctx.thisWeeksSalesPurchasesChart,
        series: _ctx.series
      }, null, 8, ["options", "series"]))
}